import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';

const API_URL = import.meta.env.VITE_API_URL || '';

// Single tRPC client for all procedures (agent.*, workflow.*, integration.*)
export const trpc = createTRPCProxyClient({
  links: [
    httpBatchLink({
      url: `${API_URL}/api/trpc`,
    }),
  ],
}) as any;
